import { useState } from 'react'
import { Header } from '@scuf/common'
import { SubscriptionAgreementContainer, Content, Title, Description, TermsConditionsContent, Actions, ButtonsSection, TermsCheckbox, AcceptenceButton, LogOutButton } from './subscription-agreement-content.styles'
import Footer from 'Components/footer';
import { BodyWrapper } from 'Containers/AppFrame.styles';

export const SubscriptionAgreementContent = ({
  slaContent = '',
  loading = false,
  enable = false,
  t = l => l,
  setEnable = () => { },
  onDecline = () => { },
  onAccept = () => { },
}) => {
  return (
    <SubscriptionAgreementContainer>
      <BodyWrapper>
        <Header title={t('HeaderTitle')} menu={false} collapseAt={700} />
        <Content>
          <div>
            <Title>{t('Title')}</Title>
            <Description>{t('Description')}</Description>
            <TermsConditionsContent>{slaContent}</TermsConditionsContent>
          </div>
          <Actions>
            <TermsCheckbox
              label={t('Aknowledge')}
              checked={enable}
              onChange={(checked) => setEnable(checked)}
            />
            <ButtonsSection>
              <LogOutButton type="inline-secondary" content={t('Decline')} onClick={onDecline} />
              <AcceptenceButton type="primary" content={t('Accept')} disabled={!enable} loading={loading} onClick={onAccept} />
            </ButtonsSection>
          </Actions>
        </Content>
        <Footer />
      </BodyWrapper>
    </SubscriptionAgreementContainer>
  )
}

export default ({
  slaContent = '',
  loading = false,
  t = l => l,
  history = {},
  logOut = () => { },
  onAccept = () => { },
}) => {
  const [enable, setEnable] = useState(false)
  const onDecline = () => {
    logOut()
    history.push('/login')
  }
  const props = {
    slaContent,
    loading,
    enable,
    t,
    setEnable,
    onDecline,
    onAccept,
  }

  return <SubscriptionAgreementContent {...props} />
}
